export enum PeriodicityTypes {
  OFTEN = 3,
  SOMETIMES = 2,
  NEVER = 1,
}

export type PeriodicityResponse = {
  periodicity: PeriodicityTypes;
  product: number;
};
